import React, { Component } from 'react';
import { numberFormat_SIN } from './numberFormat';
import logo from './../images/eliminar.png'
import logo_sin_imagen from './../images/sin_imagen.png'
class getNota extends Component {
  renderTableNota = () => {
    const array_nota = this.props.array_nota;
    const array_nota_combo = this.props.array_nota_combo;

    if(array_nota.length === 0) return null;
    /*return (
      <React.Fragment>
        {rubros.map(rubro => (
          <button key={rubro.id_rubro} className="boton_rubros"  onClick={ () => this.props.datosBusquedaSubRubro(rubro.id_rubro)}>{rubro.rubro}</button>
        )) }

      </React.Fragment>
    )*/
    //console.log(array_nota);


/*
    array_nota_combo.forEach(cp => {
      //total_precio_final=total_precio_final+Number(cp.detalle);
      cp.detalle.forEach(cp_dt => {
        total_precio_final=total_precio_final+Number(cp_dt.precio_total);
      })
    })


*/

    return (
      <div className="divTableBody">
      {array_nota.map((nota , index) => (
            <React.Fragment  key={index} >
            <div className="divTableRow" id={nota.secuencial} >
              <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCell_A' : 'divTableCell'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{nota.opcion}</div>
              <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellC_A' : 'divTableCellC'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{nota.cantidad}</div>
              <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellD_A' : 'divTableCellD'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{nota.detalle} <span style={{"color":"white"}}>{this.props.getlabelPreferenciaItem(nota.secuencial)}</span></div>
              <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellT_A' : 'divTableCellT'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{numberFormat_SIN(nota.precio_total)}</div>
              <div className="divTableCellO" >
                <img className="btn_eliminar_nota" onClick={() => this.props.onRemoveItem(nota.secuencial,nota.opcion)} src={nota.opcion==="" ?logo :logo_sin_imagen} alt="Logo" />
              </div>
            </div>
            {this.getDetalleCombo(nota.secuencial,array_nota_combo,nota)}
            </React.Fragment>
          ))}
      </div>


    )
  }
  getDetalleCombo = (secuencial,array_nota_combo,nota)=> {
       const list = array_nota_combo.filter(cp_dt => cp_dt.secuencial === secuencial);
       //console.log(list.length)
       return (
         list.map(nota_combo => (
          nota_combo.detalle.map((cp_dt , index) => (
            <React.Fragment  key={index} >
              <div className="divTableRow" key ={index}>
                <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCell_A' : 'divTableCell'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{cp_dt.opcion}</div>
                <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellC_A' : 'divTableCellC'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{cp_dt.cantidad}</div>
                <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellD_A' : 'divTableCellD'} onClick={() => this.props.onSecuencial(nota.secuencial)}>-&gt; {cp_dt.detalle}</div>
                <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellT_A' : 'divTableCellT'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{numberFormat_SIN(cp_dt.precio_total)}</div>
                <div className="divTableCellO">
                  <img className="btn_eliminar_nota" src={nota.opcion==="" ?logo_sin_imagen :logo_sin_imagen} alt="Logo" />
                </div>
              </div>
              {this.getDetalleSubCombo(cp_dt,nota)}
             </React.Fragment>
           ))
         ))
       )
   }

   getDetalleSubCombo = (subnota,nota)=> {
   /// const list = array_nota_combo.filter(cp_dt => cp_dt.secuencial === secuencial);
    //console.log(list.length)
    return (
       
      subnota.detallesub.map((cp_dt , index) => (
         <div className="divTableRow" key ={index}>
           <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCell_A' : 'divTableCell'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{cp_dt.opcion}</div>
           <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellC_A' : 'divTableCellC'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{cp_dt.cantidad}</div>
           <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellD_A' : 'divTableCellD'} onClick={() => this.props.onSecuencial(nota.secuencial)}>---&gt; {cp_dt.detalle}</div>
           <div className={nota.secuencial===this.props.secuencial_actual ? 'divTableCellT_A' : 'divTableCellT'} onClick={() => this.props.onSecuencial(nota.secuencial)}>{numberFormat_SIN(cp_dt.precio_total)}</div>
           <div className="divTableCellO">
             <img className="btn_eliminar_nota" src={nota.opcion==="" ?logo_sin_imagen :logo_sin_imagen} alt="Logo" />
           </div>
          </div>
        ))
   
    )
}


  render () {
       return (
    <div className="divTable tb_nota">
      <div className="divTableHeading">
        <div className="divTableRow">
          <div className="divTableHead"></div>
          <div className="divTableHead">Cant</div>
          <div className="divTableHead">Detalle</div>
          <div className="divTableHead">Total</div>
          <div className="divTableHead"></div>
        </div>
      </div>
      {this.renderTableNota()}
      <br/>
      {this.getIndex(this.props.secuencial_actual)}
    </div>
    )
  }

  getIndex =(position)=>{
    if(position){
      //const project = document.getElementById(position);
      //project.scrollIntoView();
    }
    return(
      <></>
    )
  }

  componentDidMount() {
    if(this.props.id_cabecera>0&&this.props.id_item_preferencia===0&&this.props.id_item_combo===0)  {
      this.props.consultarDetalleFacturacionAPI(this.props.id_cabecera);
    }
  }
}
export default getNota;
